import { prospectIndustryOptions } from './prospectIndustryOptions'

// Contacts industry filter options.
//
// Derived from prospectIndustryOptions (the current LinkedIn V2 industry
// taxonomy) so Contacts and Prospects share the same industry vocabulary.
// The old hardcoded V1 list ("Computer & Network Security", "Airlines/Aviation", ...)
// no longer matched the values synced from LinkedIn or the data partnership,
// which made exact-match industry filters miss contacts.

const allIndustriesOption = {
    "backgroundColor": "white",
    'darkBackgroundColor': '#373945',
    'darkDropdownColor': '#424551',
    'darkBorderColor': '#373945',
    "darkColor": "#e8e8e8",
    "color": "#333951",
    "indicatorColor": "#8c96ad",
    "borderColor": "#dae0e8",
    "placeholderColor": "#8c96ad",
    "value": null,
    "label": "All Industries"
}

const industryOptionStyle = {
    "backgroundColor": "#eef3ff",
    'darkBackgroundColor': '#373945',
    'darkDropdownColor': '#424551',
    'darkBorderColor': '#5964ff',
    "color": "#5964ff",
    "indicatorColor": "#5964ff",
    "borderColor": "#5964ff",
    "placeholderColor": "#7a89fc"
}

// Same order as the Prospects industry dropdown (prospectIndustryOptions),
// so both filters list industries identically.
export const industryOptions = [
    allIndustriesOption,
    ...prospectIndustryOptions
        .filter((option: any) => option.value)
        .map((option: any) => ({
            ...industryOptionStyle,
            value: option.value,
            label: option.label
        }))
]
